import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ShopProvider } from "./context/ShopContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ShopProvider>
        <AuthProvider>
          <CartProvider>
            <App />
            <Toaster position="top-right" richColors closeButton />
          </CartProvider>
        </AuthProvider>
      </ShopProvider>
    </BrowserRouter>
  </React.StrictMode>
);
